export default __webpack_public_path__ + "static/media/blueLeftArrow.2dd1eb25.svg";